import { CSRF_HEADER_NAME } from './constants';
import { refreshSubpathJWT } from './refreshJWT';

export interface BridgeClientOptions {
  refreshJWT?: () => Promise<any> /* if using NextAuth, this will be the getSession function */;
  signOut?: () => Promise<any>;
}

export const getBridgeClientFetch = (
  service: string,
  options?: BridgeClientOptions
): ((input: string, init?: RequestInit) => Promise<any>) => {
  const baseUrl = `/api/bridge/${service}`;
  const defaultHeaders = {
    'Content-Type': 'application/json',
    [CSRF_HEADER_NAME]: crypto.randomUUID(),
  };

  const refreshJWT = options?.refreshJWT || (() => Promise.resolve());
  const signOut = options?.signOut || (() => Promise.resolve());

  const request = async (
    input: string,
    init: RequestInit = {},
    isRetrying = false
  ): Promise<any> => {
    const url = baseUrl + input;
    const headers = { ...defaultHeaders, ...(init.headers || {}) };

    const response = await fetch(url, {
      ...init,
      headers,
      credentials: 'same-origin',
    });

    if (response.status === 401 && !isRetrying) {
      // the JWT might have expired, so we refresh and retry once
      const refreshed = await refreshJWT();
      if (!refreshed) {
        await signOut();
        return response;
      }
      return request(input, init, true);
    }

    if (response.status === 401 && isRetrying) {
      // if we've already retried, sign out
      await signOut();
    }

    if (response.status >= 500 && !isRetrying) {
      // if there was an error, retry the request once
      return request(input, init, true);
    }

    return response;
  };

  return request;
};

export const getSubpathBridgeClientFetch = (
  service: string
): ((input: string, init?: RequestInit) => Promise<any>) => {
  return getBridgeClientFetch(service, { refreshJWT: refreshSubpathJWT });
};
